<template>
	<div v-if="showBanner" v-bind="$attrs">
		<slot :banner="banner" :content="content"></slot>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import { useI18n } from "vue-i18n";
import { type bannerObject } from "@@/types";

const props = defineProps({
	bannerType: {
		type: String,
		default: "frontend-missing-banner",
	},
});

const banner = ref<bannerObject>({} as bannerObject);

const { locale } = useI18n();

const content = computed(() => banner.value?.content?.[locale.value] || "");

const showBanner = computed(() => Object.keys(banner.value || {}).length > 0);

onMounted(async () => {
	banner.value = await useBanners.getBanner(props.bannerType);
});
</script>
